/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Logout_QuestionInputs */

const en_logout_question = /** @type {(inputs: Logout_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to log out?`)
};

const de_logout_question = /** @type {(inputs: Logout_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sind Sie sicher, dass Sie sich abmelden möchten?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to log out?" |
*
* @param {Logout_QuestionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const logout_question = /** @type {((inputs?: Logout_QuestionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logout_QuestionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_logout_question(inputs)
	return en_logout_question(inputs)
});